import { POOP_INTERVAL_MS } from './constants';

const POOP_CAP = 5;

export interface PoopState {
  poopCount: number;
  lastPoopAt: number;
}

export interface PoopTickResult extends PoopState {
  spawned: boolean;
}

export function tickPoop(s: PoopState, dtMs: number, nowMs: number, intervalMs = POOP_INTERVAL_MS): PoopTickResult {
  if (dtMs <= 0) return { ...s, spawned: false };
  let lastPoopAt = s.lastPoopAt;
  let poopCount = s.poopCount;
  let spawned = false;
  while (nowMs - lastPoopAt >= intervalMs && poopCount < POOP_CAP) {
    lastPoopAt += intervalMs;
    poopCount += 1;
    spawned = true;
  }
  return { poopCount, lastPoopAt, spawned };
}

export function clean(s: PoopState): PoopState {
  return { poopCount: 0, lastPoopAt: s.lastPoopAt };
}
